import React from "react";
import { Box, FormControl, FormLabel, Button, ButtonGroup, Select, MenuItem, TextField } from "@mui/material";
import { InstallerJobQuestionnaire } from "../../../../models/InstallerJobQuestionnaire";

export interface InstallerQuestionProps {
    questionNumber?: number;
    question: InstallerJobQuestionnaire;
    onChange: (updatedQuestion: InstallerJobQuestionnaire) => void;
    readOnly?: boolean; // Optional prop to indicate if the question is read-only
}

export const InstallerQuestion: React.FC<InstallerQuestionProps> = ({
    question,
    onChange,
    questionNumber,
    readOnly = false,
}) => {
    const handleChange = (newAnswer: string) => {
        const updatedQuestion = {
            ...question,
            answer: newAnswer,
        };
        onChange(updatedQuestion);
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | { value: unknown }>) => {
        handleChange(event.target.value as string);
    };

    return (
        <Box mb={2}>
            <FormControl fullWidth required={question.is_required}>
                <FormLabel>
                    {questionNumber !== undefined ? `${questionNumber} - ` : ""}
                    {question.question}
                </FormLabel>

                {question.answer_type === "radio" && question.answer_options && (
                    <Box mt={1}>
                        <ButtonGroup>
                            {question.answer_options.map((option) => (
                                <Button
                                    key={option}
                                    variant={question.answer === option ? "contained" : "outlined"}
                                    onClick={() => handleChange(option)}
                                    disabled={readOnly}
                                    sx={{
                                        bgcolor:
                                            question.answer === option
                                                ? "#888" // darker gray for selected
                                                : "#ccc", // lighter gray for unselected
                                        color: "#000",
                                        borderColor: "#aaa",
                                        "&:hover": {
                                            bgcolor: question.answer === option ? "#777" : "#bbb",
                                        },
                                    }}>
                                    {option}
                                </Button>
                            ))}
                        </ButtonGroup>
                    </Box>
                )}

                {question.answer_type === "select" && question.answer_options && (
                    <>
                        <Select
                            value={question.answer ?? ""}
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            onChange={handleInputChange as any}
                            label={question.question}
                            disabled={readOnly}>
                            {question.answer_options.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </Select>
                    </>
                )}

                {question.answer_type === "text" && (
                    <TextField
                        value={question.answer ?? ""}
                        onChange={handleInputChange}
                        multiline
                        rows={2}
                        disabled={readOnly}
                        placeholder="Type your answer"
                    />
                )}
            </FormControl>
        </Box>
    );
};
